import { BaseUrlService } from "@tg4/http-infrastructure/dist/src";
import { Injectable } from "@angular/core";
import { ConfigService } from "./multi-clients/config.service";

@Injectable()
export class UrlService extends BaseUrlService {
    constructor(_configService: ConfigService) {
        super(_configService);
        this.addUrls(
            
            new Map<string, string>([
                /* String Resources */
                ["getStringResources", "api/culture"],
                /* Login and Authentication*/
                ["login", "api/account/login"],
                ["user", "api/account/user"],
                ["createEditUser", "api/account/createEditUser"],
                ["refresh_token", "api/account/RefreshToken"],
                ["forgotPassword", "api/account/forgotPassword"],
                ["changePassword", "api/account/changePassword"],
                /* Users */
                ['getFileImports', 'api/account/GetFileImports'],
                ['addUsersSyncProcess', 'api/account/AddUsersSyncProcess'],
                ['getUserNotifications', 'api/user/notifications'],
                ['userNotificationRead', 'api/user/notifications/read'],
                ['getUserProfile', 'api/user/profile'],
                ['updateUserImage', 'api/user/updateUserImage'],
                /* Dashboard */
                ["getUserCycles", "api/dashboard/cycles"],
                ["getUserAssessmentProcesses", "api/dashboard/assessmentProcesses"],
                ["cyclePrinciples", "api/dashboard/cyclePrinciples"],
                ["getGoalsProgress", "api/dashboard/goalsProgress"],
                /* Cycles */
                ['getPerformanceCycles', 'api/cycle'],
                ['getPerformanceStepsFromCycleByYear', 'api/cycle/steps'],
                ['getLastCycles', 'api/cycle/last'],
                ['getCycleById', 'api/cycle/byId'],
                ['getCycleSubordinates', 'api/cycle/participants'],
                ['enableStep', 'api/cycle/enableStep'],
                ['finishStep', 'api/cycle/finishStep'],
                ['moveUser', 'api/cycle/moveUser'],
                ['moveAllUsers', 'api/cycle/moveAllUsers'],
                ['finishStepForAllUsers', 'api/cycle/finishStepForAllUsers'],
                ['closeGoalsInputForUser', 'api/goals/input/close'],
                [
                    'closeFreeEvaluationMidYearForUser',
                    'api/freeEvaluationMidYear/close',
                ],
                ['closeTwoPlusTwoCoachingForUser', 'api/twoPlusTwoCoaching/close'],
                ['closeFinalFeedbackForUser', 'api/finalFeedback/close'],
                ['closeGoalsReviewForUser', 'api/goalsReview/close'],
                ['reopenGoalsInputForUser', 'api/goals/input/reopen'],
                [
                    'reopenFreeEvaluationMidYearForUser',
                    'api/freeEvaluationMidYear/reopen',
                ],
                [
                    'reopenFreeEvaluationMidYear',
                    'api/freeEvaluationMidYear/reopenEval',
                ],
                ['reopenFreeMidYearEvaluation', 'api/freeEvaluationMidYear/reopenEval'],
                ["midYearMoveUser", "api/freeEvaluationMidYear/moveUser"],
                ['reopenTwoPlusTwoCoachingForUser', 'api/twoPlusTwoCoaching/reopen'],
                ['reopenFinalFeedbackForUser', 'api/finalFeedback/reopen'],
                ['getSubordinateFinalFeedbacks', 'api/finalFeedback/subordinates'],
                ['saveFinalFeedbackReview', 'api/finalFeedback/saveFinalFeedbackReview'],
                ['saveFinalFeedbackValidation', 'api/finalFeedback/validation'],
                ['getSubordinateFinalFeedbackForValidation', 'api/finalFeedback/getSubordinateFeedback'],
                ['finishFinalFeedback', 'api/finalFeedback/finishFinalFeedback'],
                ['reopenGoalsReviewValidationForUser', 'api/goalsReview/validation/reopen'],
                ['reopenGoalInputValidationForCycle', 'api/goals/validation/reopen'],
                ['reopenThreeSixtyEvaluatorsValidationForUser', 'api/threeSixtyEvaluation/validation/reopen/user'],
                ['addCycle', 'api/cycle'],
                ['updateCycle', 'api/cycle'],
                ['updateCycleParticipants', 'api/cycle/participants'],
                ['getUsersList', 'api/cycle/list/users'],
                ['getAllCycleParticipants', 'api/cycle/participants/all'],
                ['getUserCycleReport', 'api/cycle/participants/report'],
                /* Goals */
                ["getUserGoals", "api/goals"],
                ["getUserGoalsForInput", "api/goals/input"],
                ["getGoalById", "api/goals/byId"],
                ["getConsentProcessGoals", "api/goals/getConsentProcessGoals"],
                ["addNewGoal", "api/goals"],
                ["addConsentGoal", "api/goals/addConsentGoal"],
                ["updateGoal", "api/goals"],
                ["deleteGoal", "api/goals"],
                ["submitGoals", "api/goals/submit"],
                ["addGoalProgress", "api/goals/progress"],
                ["addGoalComment", "api/goals/comment"],
                ["deleteGoalComment", "api/goals/comment"],
                ["getSubordinates", "api/goals/subordinates"],
                ["getSubordinateGoals", "api/goals/subordinate/goals"],
                ["setGoalFeedback", "api/goals/feedback"],
                ["reopenGoalInputValidationForUser", "api/goals/validation/user/reopen"],
                ["getConsentAttributes", "api/goals/getConsentAttributes"],
                /* Free Evaluation Mid Year */
                ["getMidYearEvaluationSummary", "api/freeEvaluationMidYear/summary"],
                ["getUsersForEvaluation", "api/freeEvaluationMidYear/user"],
                ["getMidYearEvaluations", "api/freeEvaluationMidYear"],
                ["saveMidYearEvaluation", "api/freeEvaluationMidYear"],
                ["updateMidYearEvaluation", "api/freeEvaluationMidYear"],
                ["deleteMidYearEvaluation", "api/freeEvaluationMidYear"],
                ["sendMidYearEvaluations", "api/freeEvaluationMidYear/send"],
                /* Goals Review */
                ["getUserGoalsForReview", "api/goalsReview"],
                ["updateGoalsForReview", "api/goalsReview"],
                ["submitGoalsReview", "api/goalsReview/submit"],
                ["getSubordinatesForReview", "api/goalsReview/subordinates"],
                ["saveGoalsReviewValidation", "api/goalsReview/validation"],
                ["reopenGoalsReviewForUser", "api/goalsReview/reopen"],
                /* Two Plus Two Coaching */
                ["manageCoachingRecord", "api/twoPlusTwoCoaching"],
                /* Final Feedback */
                ["getFinalFeedbackRecord", "api/finalFeedback"],
                ["manageFinalFeedbackRecord", "api/finalFeedback"],
                /* Reports */
                ["getOptionalHeaderFields", "api/report/getOptionalHeaderFields"],
                ["getGoalsReport", "api/report/getGoalsReport"],
                ["getReportCycles", "api/report/cycles"],
                ["getAvailableReports", "api/report/getAvailableReports"],
                ["getUsersForReport", "api/report/getUsersForReport"],
                ["getUsersByEmployee", "api/report/getUsersByEmployee"],
                ["getReportJobStatus", "api/report/job/status"],
                ["getExcelReportJobStatus", "api/report/job/excel/status"],
                ["getUsersReport", "api/report/getUsersReport"],
                ["getReportByEmail", "api/report/getReportByEmail"],
                /* Notepad */
                ["getUserNotes", "api/notes"],
                ["addNote", "api/notes"],
                ["updateNote", "api/notes"],
                ["deleteNote", "api/notes"],
                ["getSubordinatesNotes", "api/notes/subordinates"],
                ["getAllUsers", "api/notes/allUsersNotes"],
                ["addSubordinateNote", "api/notes/subordinates"],
                ["addAllSubordinatesNotes", "api/notes/addNotesForAllUsers"],
                /* Processes */
                ["getProcesses", "api/processes"],
                ["getProcessById", "api/processes/byId"],
                ["addProcess", "api/processes"],
                ["updateProcess", "api/processes"],
                ["deleteProcess", "api/processes"],
                ["addQuestionGroup", "api/processes/questionGroup"],
                ["updateQuestionGroup", "api/processes/questionGroup"],
                ["updateQuestionGroupAttributes", "api/processes/questionGroup/attribute"],
                ["getSelfEvaluationVersions", "api/processes/selfEvaluationVersions"],
                ["getValidationVersions", "api/processes/getValidationVersions"],
                ["getSelectionVersions", "api/processes/getSelectionVersions"],
                ["getQuestionTypeConfigs", "api/processes/questionTypeConfig"],
                ["getAllAttributesByType", "api/processes/getAllAttributesByType"],
                ["addQuestionTypeConfig", "api/processes/questionTypeConfig"],
                ["updateQuestionAttributes", "api/processes/questionTypeConfig/attribute"],
                ["getGoalInputDefaultQuestions", "api/processes/goals/defaultQuestions"],
                ["addProcessConfig", "api/processes/addProcessConfig"],
                ["updateProcessConfig", "api/processes/updateProcessConfig"],
                ["cloneProcess", "api/processes/clone"],
                /* External Client Styles*/
                ["getAllExternalClientStyles", "api/externalClientStyles/getAllExternalClientStyles"],
                /* 360 Evaluation */
                ["getUser360Evaluators", "api/threeSixtyEvaluation"],
                ["getUsersFor360Evaluation", "api/threeSixtyEvaluation/users"],
                ["saveUsersFor360Evaluation", "api/threeSixtyEvaluation"],
                ["getUsersFor360Validation", "api/threeSixtyEvaluation/validation"],
                ["getSubordinateUsersFor360Validation", "api/threeSixtyEvaluation/validation/user"],
                ["reopenSubordinateUsersFor360Validation", "api/threeSixtyEvaluation/validation/reopen"],
                ["manageSelectedUsersFor360Evaluation", "api/threeSixtyEvaluation/validation/user"],
                ["changeRelationShipOn360Evaluation", "api/threeSixtyEvaluation/evaluation/changeRelationship"],
                ["getApprovedUsersFor360Evaluation", "api/threeSixtyEvaluation/evaluation"],
                ["getApprovedUserFor360Evaluation", "api/threeSixtyEvaluation/evaluation/user"],
                ["getEvalsToDelete", "api/threeSixtyEvaluation/validation/toDelete"],
                ["save360Evaluation", "api/threeSixtyEvaluation/evaluation"],
                ["reopen360Evaluation", "api/threeSixtyEvaluation/evaluation/reopen"],
                ["delete360Evaluation", "api/threeSixtyEvaluation/evaluation/delete"],
                ["refuse360Evaluations", "api/threeSixtyEvaluation/evaluation/refuse"],
                ["send360Evaluation", "api/threeSixtyEvaluation/evaluation/send"],
                ["save360ManagerEvaluation", "api/threeSixtyEvaluation/evaluation/manager"],
                ["send360ManagerEvaluation", "api/threeSixtyEvaluation/evaluation/manager/send"],
                ["get360EvaluationResults", "api/threeSixtyEvaluation/results"],
                ["360EvaluationSendLastDay", "api/threeSixtyEvaluation/sendLastDay"],
                /* Free Evaluation End Year */
                ["getEndYearEvaluations", "api/freeEvaluationEndYear"],
                ["saveEndYearEvaluation", "api/freeEvaluationEndYear"],
                ["updateEndYearEvaluation", "api/freeEvaluationEndYear"],
                ["deleteEndYearEvaluation", "api/freeEvaluationEndYear"],
                ["sendEndYearEvaluations", "api/freeEvaluationEndYear/send"],
                ["reopenFreeEndYearEvaluation", "api/freeEvaluationEndYear/reopen"],
                ["endYearMoveUser", "api/freeEvaluationEndYear/moveUser"],
                /* Final Evaluation */
                ["getSelfEvaluation", "api/finalEvaluation/self"],
                ["saveSelfEvaluation", "api/finalEvaluation/self"],
                ["sendSelfEvaluation", "api/finalEvaluation/self/send"],
                ["sendSelfEvaluationLastDay", "api/finalEvaluation/self/sendLastDay"],
                /* Self Eval Mid Year */
                ["getSelfEvaluationMidYear", "api/finalEvaluation/selfMidYear"],
                ["saveSelfEvaluationMidYear", "api/finalEvaluation/selfMidYear"],
                ["sendSelfEvaluationMidYear", "api/finalEvaluation/selfMidYear/send"],
                /* Generic Process */
                ["getGenericProcessRecord", "api/genericProcess/record"],
                ["saveGenericProcessRecord", "api/genericProcess/record"],
                ["sendGenericProcessRecord", "api/genericProcess/record/send"],
                /* Manager Evaluation */
                ["getTeamListForEvaluation", "api/finalEvaluation/manager"],
                ["getReviewsForCalibrationGroup", "api/reviews/GetReviewsForCalibrationGroup"],
                ["getTeamUserForEvaluation", "api/finalEvaluation/manager/employee"],
                ["getPreviousEvaluations", "api/finalEvaluation/manager/employee/getPreviousEvaluations"],
                ["saveManagerEvaluation", "api/finalEvaluation/manager"],
                ["sendManagerEvaluation", "api/finalEvaluation/manager/send"],
                ["sendManagerEvaluationLastDay", "api/finalEvaluation/manager/sendLastDay"],
                ["reopenManagerEvaluation", "api/cycle/reopenManagerEvaluation"],
                // ['deleteManagerEvaluation', 'api/finalEvaluation/managerEval'],
                // ['getManagerEvaluationToDelete', 'api/finalEvaluation/toDelete'],
                /* Evaluation Calibration */
                ["getCalibrationJobStatus", "api/calibration/job/status"],
                ["getCalibrationGroups", "api/calibration/group"],
                ["getCalibrationGroupById", "api/calibration/group/byId"],
                ["getUsersForCalibration", "api/calibration/users"],
                ["createCalibrationGroup", "api/calibration/group"],
                ["updateCalibrationGroup", "api/calibration/group"],
                ["deleteCalibrationGroup", "api/calibration/group"],
                ["postCalibrationGroupExport", "api/calibration/group/participants/comparison"],
                ["updateResumeGroup", "api/calibration/group/participants/updateResume"],
                ["getCalibrationGroupUsers", "api/calibration/group/participants"],
                ["resetNineBoxCalibrationGroup", "api/calibration/group/resetNineBox"],
                ["getCalibrationGroupSummary", "api/calibration/group/summary"],
                ["getCalibrationUserSummary", "api/calibration/group/participant"],
                ["updateGroupParticipantQuadrant", "api/calibration/group/participant/move-quadrant"],
                ["reorderGroupParticipants", "api/calibration/group/participant/reorder-participants"],
                ["getCalibrationGroupParticipantEvaluationLog", "api/calibration/group/participant/evaluationLog"],
                ["getCalibrationGroupParticipantsReport", "api/calibration/group/participants/report"],
                ["getCalibrationGroupParticipantsReportPDF", "api/calibration/group/participants/report/pdf"],
                ["getCalibrationGroupReportPDF", "api/calibration/pdf"],
                ["shareCalibrationGroup", "api/calibration/group/sharing"],
                ["getUsersToShareCalibrationGroup", "api/calibration/group/sharing/users"],
                ["leaveSharedCalibrationGroup", "api/calibration/group/sharing/leave"],
                ["updateGroupMeetingStatus", "api/calibration/group/meeting"],
                ["updateCalibrationGroupNotes", "api/calibration/group/notes"],
                ["updateCalibrationGroupUserNotes", "api/calibration/group/participant/notes"],
                ["importCalibrationGroupParticipants", "api/calibration/group/participants/import"],
                ["getGroupParticipants", "api/calibration/group/searchParticipants"],
                /* Ai Summary  */
                ["getReviewsAiUserSummary", "api/reviews"],
                ["hasAccessToReview", "api/reviews/hasAccessToReview"],
                ["getVisibilityRules", "api/reviews/getVisibilityRules"],
                ["getPrinciplesConfig", "api/parameters/getPrinciplesConfig"],
                ["getDashboardPrinciples", "api/parameters/getDashboardPrinciples"],
                ["postPrinciplesConfig", "api/parameters/postPrinciplesConfig"],
                ["addVisibilityRule", "api/reviews/addVisibilityRule"],
                ["editVisibilityRule", "api/reviews/editVisibilityRule"],
                ["deleteVisibilityRuleGroup", "api/reviews/visibilityRuleGroup"],
                /* Attributes */
                ["searchAttributes", "api/attributes/search"],
                ["searchAttributesToFeedback", "api/attributes/searchAttributesToFeedback"],
                ["getReviewAttributes", "api/attributes/getReviewAttributes"],
                ["usersAttributesFilteredToFeedback", "api/attributes/usersAttributesFilteredToFeedback"],
                ["getGroupedAttributes", "api/attributes/getGroupedAttributes"],
                ["getUsedAttributeTypes", "api/attributes/getUsedAttributeTypes"],
                ["getUserAttributes", "api/attributes/getUserAttributes"],
                ["getAllAttributesByType", "api/attributes/getAllAttributesByType"],
                /* OKR */
                ["getOkrObjectivesFrontPage", "api/OKR/ObjectivesFrontPage"],
                ["getOKRObjectivesByAttributes", "api/OKR/ObjectivesByAttributes"],
                ["getOKRObjectives", "api/OKR/Objectives"],
                ["getOkrVisibilities", "api/OKR/Visibilities"],
                ["getOkrKeyResult", "api/OKR/KeyResult"],
                ["addOkrObjective", "api/OKR/Objective"],
                ["addKeyOKRKeyResultProgress", "api/OKR/KeyResultProgress"],
                ["addOkrVisibility", "api/OKR/Visibility"],
                ["deleteOkrObjectives", "api/OKR/Objectives"],
                ["deleteOkrVisibility", "api/OKR/Visibility"],
                ["updateOkrObjective", "api/OKR/Objective"],
                ["updateKeyResultComment", "api/OKR/KeyResultComment"],
                /* Feedback */
                ["getFeedbackEnabledAttributes", "api/Feedback/FeedbackEnabledAttributes"],
                ["getFeedbackEnabledAttributeById", "api/Feedback/FeedbackEnabledAttributeById"],
                ["addFeedbackEnabledAttribute", "api/Feedback/FeedbackEnabledAttribute"],
                ["updateFeedbackEnabledAttribute", "api/Feedback/FeedbackEnabledAttribute"],
                ["deleteFeedbackGroupEnabledAttribute", "api/Feedback/FeedbackEnabledAttribute"],
                ["getFeedbackPrinciples", "api/Feedback/FeedbackPrinciples"],
                ["createFeedback", "api/Feedback/Feedback"],
                ["getFeedbackDashboard", "api/Feedback/FeedbackDashboard"],
                ["getFeedbacks", "api/Feedback/FeedbackUser"],
                ["createFeedbackReaction", "api/Feedback/FeedbackReaction"],
                ["getFeedbackRecordUser", "api/Feedback/FeedbackRecordUser"],
                ["getFeedbackUsers", "api/Feedback/FeedbackUsers"],
                ["markFeedbackAsRead", "api/Feedback/MarkFeedbackAsRead"],
                /* User */
                ["getUsers", "api/user"],
                ["getUser", "api/user/byId"],
                ["getLastFrozenStructure", "api/user/lastFrozenStructure"],
                ["addFrozenStructure", "api/user/frozenStructure"],
                /* User Accesses */
                ["getUsersVisibilityAccesses", "api/userAccess"],
                ["getUserVisibilityRules", "api/userAccess/rules"],
                ["updateIndividualVisibilityRules", "api/userAccess/individual"],
                ["deleteIndividualVisibilityRule", "api/userAccess/individual"],
                ["importVisibilityParticipants", "api/userAccess/individual/import"],
                ["getAllRoles", "api/roles"],
                /* Diversity Check */
                ["getLatestDiversityCheck", "api/DiversityCheck"],
                ["acceptDiversityCheck", "api/DiversityCheck/accept"],
                /* External Evaluation */
                ["getAllExternalEvaluations", "api/externalEvaluation/getAll"],
                ["getExternalEvaluation", "api/externalEvaluation"],
                ["searchExternalEvaluationAttributes", "api/externalEvaluation/search"],
                ["authorizeExternalEvaluation", "api/externalEvaluation/authorize"],
                ["resendExternalEvaluation", "api/externalEvaluation/resend"],
                ["updateExternalEvaluation", "api/externalEvaluation"],
                ["deleteExternalEvaluation", "api/externalEvaluation"],
                ["sendExternalEvaluation", "api/externalEvaluation/send"],
                ["reopenExternalEvaluation", "api/externalEvaluation/reopen"],
                ["updateExternalUser", "api/externalEvaluation/externalUser"],
                ["addExternalUser", "api/externalEvaluation/externalUser"],
                ["getExternalEvaluationReport", "api/externalEvaluation/getReport"],
                /* HR Channel */
                ["getHrChannelUsers", "api/hrchannel/users"],
                ["getHrChannelUserMessages", "api/hrchannel/users"],
                ["sendMessageFromHr", "api/hrchannel/users/send"],
                ["readHrMessages", "api/hrchannel/users/read"],
                ["getHrChannelMessagesFromHr", "api/hrchannel/messages"],
                ["sendMessageToHr", "api/hrchannel/messages/send"],
                /*  OPEN / CLOSE All users Process Cycle*/
                ["openCloseProcessForAllUsersCycle", "api/cycle/openCloseProcessForAllUsersCycle"],
                ["impersonateUser", "api/cycle/impersonateUser"],
                ["leaveImpersonation", "api/cycle/leaveImpersonation"],
                ["getManagerComparisionBook", "api/finalEvaluation/manager/comparisonBook"],
                ["getHeadEvaluations", "api/headEvaluation"],
                ["saveHeadEvaluation", "api/headEvaluation"],
                ["reopenHeadEvaluation", "api/headEvaluation"],
            ]),
        );
    }
}
